var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 7.55556V32.4444C36 34.4 34.4 36 32.4445 36H7.55559C5.60003 36 4.00003 34.4 4.00003 32.4444V7.55556C4.00003 5.6 5.60003 4 7.55559 4H32.4445C34.4 4 36 5.6 36 7.55556ZM18.2222 28.0177L14.4888 23.5199C14.1155 23.0754 13.44 23.0932 13.1022 23.5554L8.67552 29.2443C8.21329 29.831 8.62218 30.6843 9.36885 30.6843H30.6844C31.4133 30.6843 31.84 29.8488 31.3955 29.2621L25.1555 20.9421C24.8 20.4621 24.0888 20.4621 23.7333 20.9243L18.2222 28.0177Z",
    fill: "#555893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.13adebfb.svg";
export { ForwardRef as ReactComponent };